import { useContext, useEffect, useState } from 'react'
import { getLocalStorageCheckoutKey, getSegmentAnonymousId } from '../utils'
import { createCheckout, queryCheckout } from '../shopify'
import { useShopify } from '../contexts/shopify'
import { LayoutContext } from '../contexts'

const hydrateCheckout = async (
  client,
  storeSubdomain,
  replaceCheckout,
  localCurrency,
) => {
  let checkoutId = localStorage.getItem(
    getLocalStorageCheckoutKey(storeSubdomain),
  )
  let checkout

  const createValidCheckout = async (client, lineItems = null) => {
    const {
      data: {
        checkoutCreate: { checkout: shopifyCheckout },
      },
    } = await createCheckout(client, {
      input: {
        presentmentCurrencyCode: localCurrency.code,
        lineItems,
      },
    })
    return shopifyCheckout
  }

  const queryValidCheckout = async (id, client) => {
    const {
      data: { node },
    } = await queryCheckout(client, { id })
    return node
  }

  if (checkoutId) {
    let node
    try {
      node = await queryValidCheckout(checkoutId, client)
      if (node && node.orderStatusUrl) {
        // last cart checked out
        checkout = await createValidCheckout(client)
      } else {
        // last cart haven't checked out
        if (node.currencyCode === localCurrency.code) {
          checkout = node
        } else {
          const lineItems = node.lineItems.edges.map(
            ({
              node: {
                quantity,
                customAttributes,
                variant: { id },
              },
            }) => ({
              variantId: id,
              quantity,
              customAttributes,
            }),
          )
          checkout = await createValidCheckout(client, lineItems)
        }
      }
      if (
        !!node.lineItems.edges.length &&
        node.lineItems.edges.every((lineItem) => {
          return !lineItem.node.variant
        })
      ) {
        checkout = await createValidCheckout(client)
      }
    } catch (error) {
      checkout = await createValidCheckout(client)
    }
  } else {
    checkout = await createValidCheckout(client)
  }
  localStorage.setItem(
    getLocalStorageCheckoutKey(storeSubdomain),
    checkout?.id || null,
  )

  const segmentId = await getSegmentAnonymousId()
  replaceCheckout({ ...checkout, storeSubdomain }, segmentId)
}

export const useCheckoutHydration = () => {
  const { currency: localCurrency } = useContext(LayoutContext)
  const { stores, replaceCheckout, checkouts } = useShopify()

  useEffect(() => {
    Object.values(checkouts).forEach(({ id, storeSubdomain }) => {
      if (!id && localCurrency) {
        hydrateCheckout(
          stores[storeSubdomain].client,
          storeSubdomain,
          replaceCheckout,
          localCurrency,
        )
      }
    })
  }, [localCurrency])
}
